export default __webpack_public_path__ + "static/aurec-home-logo-f56e38ae41c7470e621b132e362fb0b5.svg";